export default __webpack_public_path__ + "locales/sr-Latn-RS/Settings.json?hash=46c3f3d2d4c355c7ec2cc3e01fbff3dd";